<template>
    <v-app>
        <v-navigation-drawer app v-model="sidebarOpen">
            <v-list dense>
                <v-subheader>Table of Contents</v-subheader>
                <v-list-tile v-for="(section, i) in $store.state.preview.snapshot" :key="section.id" :to="`/${section.sort_order + 1}`">
                    <v-list-tile-title>{{ section.title || `Chapter ${i + 1}` }}</v-list-tile-title>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>

        <v-content>
            <v-btn fab fixed flat small @click="sidebarOpen = !sidebarOpen" class="ml-2 mt-3">
                <v-icon>fal fa-list-ul</v-icon>
            </v-btn>

            <transition-page :slide-direction-callback="determineSlideDirection">
                <router-view :key="$route.params.section_number"/>
            </transition-page>
        </v-content>

        <audio-player
            v-if="$store.state.preview.options.has_narrations"
            :file="activeChapterMp3"
            :ended="goToNextChapter"
            @started="$store.state.audioPlaying = true"
            @ended="$store.state.audioPlaying = false"
            ref="player"
        ></audio-player>
    </v-app>
</template>

<script>
import TransitionPage from './components/TransitionPage'

export default {
    components: {TransitionPage},

    data() {
        return {
            sidebarOpen: true,
            transitionName: null,
            CHAPTER_AUDIO_TRANSITION_DELAY: 2000,
        }
    },

    mounted() {
        if (this.$store.state.preview.options.has_narrations) {
            this.$bus.$on('playFirstChapter', () => {
                this.$store.state.audioPlaying = false

                this.$router.push('/')

                this.$refs.player.play()
            })
        }
    },

    methods: {
        goToNextChapter() {
            let sectionNumber = this.$route.params.section_number

            if (sectionNumber === undefined) {
                this.$router.push('/1')

                setTimeout(() => {
                    this.$refs.player.play()
                }, this.CHAPTER_AUDIO_TRANSITION_DELAY)
            }

            let nextChapter = parseInt(sectionNumber || 0) + 1

            if (this.$store.state.preview.snapshot[nextChapter]) {
                this.$router.push('/' + nextChapter)

                setTimeout(() => {
                    this.$refs.player.play()
                }, this.CHAPTER_AUDIO_TRANSITION_DELAY)
            }
        },
        determineSlideDirection(to, from) {
            let toChapter = parseInt(to.params.section_number || 0)
            let fromChapter = parseInt(from.params.section_number || 0)

            return toChapter < fromChapter ? `slide-right` : `slide-left`
        },
    },

    computed: {
        activeChapterMp3() {
            let sectionNumber = this.$route.params.section_number

            if (sectionNumber === undefined) {
                return this.$store.state.preview.options.intro_mp3_url
            }

            return this.$store.state.preview.snapshot[parseInt(sectionNumber) - 1].mp3_url
        },
    },

    watch: {
        $route: {
            immediate: true,
            handler() {
                // stop playing previous chapter, start next one
                if (this.$store.state.audioPlaying) {
                    this.$refs.player.stop()

                    setTimeout(() => {
                        this.$refs.player.play()
                    }, this.CHAPTER_AUDIO_TRANSITION_DELAY)
                }
            }
        },
    },
}
</script>

<style lang="scss">

</style>
